import React, { Component } from 'react';
import { Dialog, DialogActions, DialogContent, Grid, TextField, InputLabel, FormControl, Select, MenuItem, Step, Stepper, StepLabel, FormHelperText, Divider } from '@material-ui/core'
import PropTypes from 'prop-types'

//components
import { BtnForm } from '../../general/BotonesAccion';
import AppBarModal from '../../general/AppBarModal'
import TareasTerminadas from "../../general/TareasTerminadas";
import { consulta, crear_form_data, formulario } from '../../../global/js/funciones'
import emma_w from '../../../global/imagenes/emma_w.png';
import AlertasSimple from '../../general/AlertasSimple';

const configStep = ['Consultar Usuario', 'Datos'];


class ModalHabilitarUsuario extends Component {
    constructor(props) {
        super(props)
        this.state = {
            cargando: true,
            datos: [],
            idDetallePostulante: 0,
            cod_prestador: '',
            titulo_val: '',
            activeStep: 0,
            numero_iden: { 'valor': '' },
            rolUsuario: { 'valor': '' },
            correo: { 'valor': '' },
            nom_empresa: { 'valor': '' },
            opcionesRol: [
                { 'nombre': 'Empresa', 'valor': '1' },
                { 'nombre': 'Graduado', 'valor': '2' }
            ]
        }
    }

    async componentDidUpdate({ modalHabilitarUsuario }, { }) {
        let { modalHabilitarUsuario: modalHabilitarUsuarioNew } = this.props;
        if (modalHabilitarUsuario !== modalHabilitarUsuarioNew) {
            if (modalHabilitarUsuarioNew) this.obtenerDatosIniciales();
            else this.resetState()
        }
    }

    resetState = () => {
        this.setState({ activeStep: 0, numero_iden: { 'valor': '' }, rolUsuario: { 'valor': '' }, correo: { 'valor': '' }, nom_empresa: { 'valor': '' } })
    }

    validarUsuario = data => {
        return new Promise(resolve => {
            consulta(`api/v1.0/portal/validar_usuario`, data, 'post', (error, estado, resp) => {
                resolve(resp)
            })
        })
    }

    obtenerDatosIniciales() {
        this.setState({ cargando: false })
    }

    onChange = ({ target }) => {
        let { value, name } = target;
        this.setState({
            [name]: { valor: value }
        })
    }

    conError(valor) {
        return valor ? true : false;
    }

    req = (clave, errorFlag) => {
        const obligatorio = "Este campo es obligatorio";
        const estadoObj = { ...this.state };

        if (!estadoObj[clave].valor) {
            estadoObj[clave].error = obligatorio;
            errorFlag.value = true;
        } else {
            estadoObj[clave].error = "";
        }
        this.setState(estadoObj);
    };

    validateStep = () => {
        let { activeStep, rolUsuario } = this.state

        const errorFlag = { value: false };

        if (activeStep === 0) {
            this.req("numero_iden", errorFlag);
            this.req("rolUsuario", errorFlag);
        } else if (activeStep === 1) {
            // // Paso 
            const estadoObj = { ...this.state };
            const esValido = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(estadoObj['correo'].valor);

            if (!esValido) {
                estadoObj['correo'].error = "Digite un correo valido."
                errorFlag.value = true;
            }
            else estadoObj['correo'].error = "";
            this.setState(estadoObj);

            if (rolUsuario.valor == 1) this.req("nom_empresa", errorFlag);
        }
        return errorFlag.value;
    };

    handleNext = async () => {
        let sw = false
        let { activeStep, numero_iden, rolUsuario, correo, nom_empresa } = this.state
        let { actualizarMensaje } = this.props
        if (this.validateStep()) return;

        this.setState({ cargando: true, correo: { 'valor': '' }, nom_empresa: { 'valor': '' } })
        if (activeStep === 0) {
            let data = { numero_iden: numero_iden.valor, rolUsuario: rolUsuario.valor }
            let res = await this.validarUsuario(data);
            sw = res.sw
            if (res.data) {
                this.setState({ correo: { 'valor': res.data.correo }, nom_empresa: { 'valor': `${res.data.primer_nombre} ${res.data.primer_apellido}` } })
            }
            if (!sw) actualizarMensaje({ titulo: res.mensaje, tipo: 'info', mostrar: true, tiempo: 6000 });
        } else if (activeStep === 1) {
            let data = { numero_iden: numero_iden.valor, rolUsuario: rolUsuario.valor, correo: correo.valor, nom_empresa: nom_empresa.valor }
            await this.onSubmit(data);

        }
        this.setState({ cargando: false })


        if (sw) this.setState(({ activeStep }) => ({ activeStep: Math.min(2, activeStep + 1) }));
    };

    handleBack = () => this.setState(({ activeStep }) => ({ activeStep: Math.max(0, activeStep - 1) }));

    onSubmit = async (datos) => {
        let { actualizarMensaje, mostrarModalHabilitarUsuario } = this.props
        let data = await crear_form_data(datos);
        return new Promise((resolve) => {

            formulario(`api/v1.0/portal/habilitar_usuario`, data, 'post',
                (error, estado, resp) => {
                    let tipo = 'error', titulo = 'Ha ocurrido un error.'
                    if (!error) {
                        if (estado === 200) {
                            tipo = 'success'; titulo = resp?.mensaje || 'Solicitud creada.'
                            mostrarModalHabilitarUsuario(false)
                        }
                        else if (estado === 302) { tipo = 'info'; titulo = resp?.mensaje || 'Información' }
                        else { tipo = 'info'; titulo = resp?.mensaje || 'No se pudo completar la acción.' }
                    }
                    actualizarMensaje({ titulo, tipo, mostrar: true, tiempo: 6000 })
                    resolve(resp)
                }
            )
        });
    };


    pintar = () => {
        let { activeStep, numero_iden, rolUsuario, opcionesRol, correo, nom_empresa } = this.state

        switch (activeStep) {
            case 0:
                return (
                    <Grid container direction={'row'} justifyContent={'center'} spacing={3}>
                        <Grid item xs={12} md={6}>
                            <FormControl className="form-control" error={this.conError(rolUsuario.error)}
                            >
                                <InputLabel>Tipo Usuario</InputLabel>
                                <Select value={rolUsuario.valor} onChange={this.onChange} name={'rolUsuario'} id={'rolUsuario'}>
                                    {opcionesRol.map(op => <MenuItem key={op.valor} value={op.valor}>{op.nombre}</MenuItem>)}
                                </Select>
                                {rolUsuario.error && <FormHelperText>{rolUsuario.error}</FormHelperText>}
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField type="number" fullWidth label="Numero Identificacion" name="numero_iden" id={'numero_iden'} value={numero_iden.valor} onChange={this.onChange} error={this.conError(numero_iden.error)} helperText={numero_iden.error}
                            />
                        </Grid>
                    </Grid>
                )
            case 1:
                return (
                    <Grid container direction={'row'} justifyContent={'center'} spacing={3}>
                        <Grid item xs={12} md={rolUsuario.valor == 1 ? 6 : 12}><TextField type="email" fullWidth label="Correo" name="correo" id={'correo'} value={correo.valor} onChange={this.onChange} error={this.conError(correo.error)} helperText={correo.error} /></Grid>
                        {rolUsuario.valor == 1 && <Grid item xs={12} md={6}><TextField type="nom_empresa" fullWidth label="Nombre Empresa" name="nom_empresa" id={'nom_empresa'} value={nom_empresa.valor} onChange={this.onChange} error={this.conError(nom_empresa.error)} helperText={nom_empresa.error} /></Grid>}
                    </Grid>
                )
            default:
                return <TareasTerminadas imagen={emma_w} mensaje='Esta bandeja esta vacía' widthImg='10%' marginTop='10%' />
        }
    }

    render() {
        let { modalHabilitarUsuario, mostrarModalHabilitarUsuario } = this.props
        let { cargando, activeStep, rolUsuario } = this.state
        return (
            <Dialog open={modalHabilitarUsuario} onClose={() => mostrarModalHabilitarUsuario(false)} fullWidth={true} maxWidth="sm" fullScreen={window.innerWidth < 600}>
                <AppBarModal titulo={'Activar Usuario CUCJOBS' } mostrarModal={() => mostrarModalHabilitarUsuario(false)} titulo_accion="" />
                <DialogContent style={{ padding: 0 }} className="scroll">
                    {!cargando ?
                        <Grid container style={{'padding': '20px'}}>
                            <Grid item xs={12} md={12}>
                                <Stepper activeStep={activeStep}>
                                    {
                                        configStep.map(label => (
                                            <Step key={label}>
                                                <StepLabel><p>{label}</p></StepLabel>
                                            </Step>
                                        ))
                                    }
                                </Stepper>
                            </Grid>
                            {(rolUsuario.valor == 1 && activeStep == 0) && <AlertasSimple tipo='info' titulo='Tener en cuenta' sub_titulo='Recuerda ingresar solo el número base del NIT, sin guion ni dígito de verificación. Ejemplo: 890104530-9 → 890104530' />}
                            <Grid item xs={12} style={{'marginTop': '20px'}}>
                                {this.pintar()}
                            </Grid>
                        </Grid>
                        :
                        <TareasTerminadas mensaje='Cargando..' marginTop='7%' imagen={emma_w} widthImg="7%" cargando={true} />
                    }
                </DialogContent>
                <DialogActions>
                    {/* Botón Atrás */}
                    {!cargando && activeStep > 0 && (
                        <BtnForm texto="Atrás" callback={this.handleBack} />
                    )}

                    {/* Botón Siguiente / Guardar */}
                    {!cargando && activeStep === 0 && (
                        <BtnForm texto="Siguiente" callback={this.handleNext} />
                    )}

                    {!cargando && activeStep === 1 && (
                        <BtnForm texto="Guardar" callback={this.handleNext} />
                    )}
                    <Divider
                        orientation="vertical"
                        flexItem
                        style={{ margin: '0 12px', background: 'rgba(183,14,12,0.25)' }}
                    />
                    <BtnForm texto="CERRAR" callback={() => mostrarModalHabilitarUsuario(false)} />
                </DialogActions>
            </Dialog>
        )
    }


}



ModalHabilitarUsuario.propTypes = {
    //funciones
    mostrarModalHabilitarUsuario: PropTypes.func.isRequired,
    modalHabilitarUsuario: PropTypes.func.isRequired,
    actualizarMensaje: PropTypes.func.isRequired,
}

export default ModalHabilitarUsuario